import { Link } from '@remix-run/react';
import React from 'react';
interface Breadcrumb {
    href: string;
    label: string;
}

export const ProjectBreadcrumb = ({
    breadcrumbs,
}: {
    breadcrumbs: Breadcrumb[];
}) => {
    return (
        <div className="flex items-center gap-3.5">
            {breadcrumbs.map((breadcrumb, index) => (
                <React.Fragment key={breadcrumb.href}>
                    <Link to={breadcrumb.href}>
                        <span className="text-2.5 font-medium uppercase tracking-[0.05rem] text-[#848484] hover:text-gray-700">
                            {breadcrumb.label}
                        </span>
                    </Link>
                    {index !== breadcrumbs.length - 1 && (
                        <span className="text-2.5 font-medium uppercase tracking-[0.05rem] text-[#848484]">{`/`}</span>
                    )}
                </React.Fragment>
            ))}
        </div>
    );
};
